import React from 'react'
import {Modal, ListGroup, Badge, Alert} from 'react-bootstrap'

const HelpArticleModal = ({article, onClose}) => {
  return (
    <Modal show={!!article} onHide={onClose} size='lg' scrollable>
      {article && (
        <>
          <Modal.Header closeButton>
            <div>
              <Badge bg='light' text='dark' className='border mb-1'>
                {article.category}
              </Badge>
              <Modal.Title className='fs-5'>{article.title}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <p className='text-muted mb-4'>{article.summary}</p>
            <ListGroup variant='flush' className='mb-4'>
              {article.steps.map((step) => (
                <ListGroup.Item key={step.order} className='px-0 py-3 border-bottom'>
                  <div className='d-flex gap-3'>
                    <div
                      className='d-flex align-items-center justify-content-center bg-primary text-white rounded-circle flex-shrink-0'
                      style={{width: '28px', height: '28px', fontSize: '13px', fontWeight: 600}}
                    >
                      {step.order}
                    </div>
                    <div className='flex-grow-1'>
                      <p className='mb-0'>{step.text}</p>
                      {step.imageUrl && (
                        <img
                          src={step.imageUrl}
                          alt={`Adım ${step.order}`}
                          className='img-fluid rounded mt-2'
                          style={{maxHeight: '300px'}}
                        />
                      )}
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
            {article.notes && article.notes.length > 0 && (
              <Alert variant='info' className='mb-0'>
                {article.notes.map((note, idx) => (
                  <p key={idx} className={idx < article.notes.length - 1 ? 'mb-2' : 'mb-0'}>
                    <strong>Not:</strong> {note}
                  </p>
                ))}
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-secondary' onClick={onClose}>
              Kapat
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  )
}

export {HelpArticleModal}
